import { Component, Input } from "@angular/core";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Dictionary } from "../store/models/common_types";
import { ResearchGridDataService } from "../research-grid-page/research-grid-data.service";
import { AppService } from "../app.service";
import { VAIconRegistryService, print } from "@va/core-library/icons";

@Component({
  selector: "app-print-renderer",
  template: `
    <p *ngIf="dataValue.show" class="clickable" (click)="onClickPrint(docId)">
      <ng-template #indicatorTemplate
        ><va-icon
          [name]="faSpinner"
          isFontAwesome="true"
          [spin]="true"
        ></va-icon
      ></ng-template>
      <nz-spin *ngIf="loading" nzSimple [nzIndicator]="indicatorTemplate">
      </nz-spin>
      <va-icon *ngIf="!loading" size="small" name="print"></va-icon>
    </p>
  `,
  styles: [".clickable {cursor: pointer; margin:0}"],
})
export class PrintRendererComponent {
  @Input() dataValue: Dictionary<any>;
  @Input() docId: number;
  faSpinner = faSpinner;
  loading = false;

  constructor(
    private dataService: ResearchGridDataService,
    private appService: AppService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([print]);
  }

  onClickPrint(docId: number) {
    this.loading = true;
    this.dataService.getPrintDocumentURL(docId).subscribe(
      (data) => {
        const printUrl = data.Data.Url;
        window.open(printUrl, "_blank");
        this.loading = false;
      },
      () => {
        console.error("Getting print document failed");
        this.loading = false;
      },
    );
    const extras = {
      beginning_state_referrer: "Dedicated_Research_Page",
      research_id: docId,
      research_type: this.dataValue.type,
    };
    this.appService.logUserAction(
      event,
      this.dataValue.ticker,
      "",
      "Research_SendToPrint_From_DedicatedPage",
      extras,
      "",
      "",
    );
  }
}
